import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Loader from "./component/loader";
import AOS from "aos";
import gotoTop from "./images/go_top.png"
import MainPage from "./container/mainPage";
import TermsCondition from "./container/termCondition";
import PrivacyPolicy from "./container/privacyPolicy";
function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    AOS.init({
      duration: 1500,
      delay: 200,
      // once: false,
    });
  }, []);
  useEffect(() => {
    setLoading(true);
    const handleLoading = () => {
      setLoading(false);
      AOS.refresh();
    };

    const timeout = setTimeout(handleLoading, 800);

    return () => clearTimeout(timeout);
  }, [location]);

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  return (
    <>
      {loading && <Loader />}
      <div className="app">
      <span className="scroll-to-top" onClick={scrollToTop}>
        <img src={gotoTop} alt="image"/>
      </span>
    </div>
      <Routes>
        <Route path="/" Component={MainPage} />
        <Route path="/term" Component={TermsCondition} />
        <Route path="/policy" Component={PrivacyPolicy} />
      </Routes>

  
    </>
  );
}

export default App;
